import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Subscription, Subject } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';
import { OpenaiService } from 'src/app/openai/openai.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';



@Component({
    selector: 'app-titles-tab',
    templateUrl: './titles-tab.component.html',
    styleUrls: ['./titles-tab.component.scss'],
    standalone: false
})
export class TitlesTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService, private talentInsightsService: TalentInsightsService, private openaiService: OpenaiService) { }
  companyDetails: any;
  currentCompanyName: any;
  titles: any = [];
  functions: any = [];
  functionStartIndex: number = 0;
  jobTitleStartIndex: number = 0;
  totalFunctionResultCount: number = 0;
  jobTitleAggregatesCount: number = 50;
  jobTitleIsViewMore: boolean = true;
  functionAggregatesCount: number = 50;
  functionIsViewMore: boolean = true;
  showTitleLoader: boolean = true;
  alternatecompanyNames: any[] = [];

  /**total result count for titles */
  totalTitleResultCount = 0;

  /** start index in title page */
  startTitle: number = 0;
  /**End index in title page */
  endTitle: number = 10;
  /**Number of title items on each of page */
  pageSizeTitle: number = 10;
  /**Current page number of titles */
  currentPageTitle: number = 1;
  /**Total items in titles page */
  totalCountTitle = 0;

  /** start index in function page */
  startFunction: number = 0;
  /**End index in function page */
  endFunction: number = 5;
  /**Number of items on each of function page */
  pageSizeFunction: number = 5;
  /**Current page number in function */
  currentPageFunction: number = 1;
  /**Total items in function page*/
  totalCountFunction = 0;
  titlessubscription: Subscription;
  titleemptystate: Boolean = false;
  functionemptystate: Boolean = false;
  titlesdata: any;
  displayedColumns: string[] = ['key', 'doc_count', 'graph', 'avg_tenure', 'job_doc_count'];
  functionsdata: any
  displayedfunctionsColumns: string[] = ['key', 'doc_count', '%total', 'median_tenure', 'job_doc_count'];
  @ViewChild(MatSort) titlesort: MatSort;
  @ViewChild('functionsort') functionsort = new MatSort();
  titlesortdata: any;
  functionsortdata: any;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};
  jobtitlesdata: any = [];
  titlesdataAI: any;
  functionsaidata: any = []

  /**
   * Data for  seniority tab in titles container to share in ai export
   */
  seniorityAiData: any = [];

  insightsExportSubscription: Subscription = null;

  /**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "jobTitles": "Job Titles",
    "TalentCount": "Talent Count",
    "%OfTotal": "% of Total",
    "MedianTenure": "Median Tenure",
    "JobDemand": "Job Posts"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  seniorityData: any = [];
  senioritySortData: any;
  @ViewChild('senioritySort') senioritySort: MatSort;
  seniority: any = [];
  senioritydata: any;
  displayedSeniorityColumns: string[] = ['key', 'doc_count', 'job_doc_count'];
  seniorityEmptyState: boolean = false;
  combinedAggregates: any;
  combinedIndustry: any;
  combinedSkills: any
  combinedJobtitle: any;
  combinedLocation: any
  hasJobDemand: boolean = false;
  hasMedianSalarySeniority: boolean = false;
  senioritytableHeaderObj = {
    "Title": "Title Levels",
    "TalentCount": "Talent Count",
        "JobDemand": "Job Posts",
  }

  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
  sliderFunctionsPayload:any
  sliderSeniorityPayload:any
  hasJobListingAccess:any
filterData: any;
aiSuggestions: any;
  ngOnInit(): void {

    this.startTitle = 0;
    this.endTitle = 10;
    this.currentPageTitle = 1;
    this.startFunction = 0;
    this.endFunction = 5;
    this.currentPageFunction = 1;
    this.setCompanyDetails();
    this.getJobtitleSkillSuggestions();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      const extra = _methodDetails;
      this.filterData = this.filterDataHandlerService.fetchFilterData;
        if (extra?.filterType == 'skills' || extra?.filterType == 'jobtitle' || extra?.filterType == 'keyword' || extra?.filterType == 'pastjobtitle' || extra?.filterType == 'search' || extra?.filterType == 'allfilters') {
        this.getJobtitleSkillSuggestions();
      } else if (extra?.filterType == 'location' || extra?.filterType == 'industry' || extra?.filterType == 'company' || extra?.filterType == 'seniority' || extra?.filterType == 'function' || extra?.filterType == 'functions' || extra?.filterType == 'locationRange') {
        this.fetchPageData();
      } else {
        this.fetchPageData();
      }
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    this.hasJobListingAccess = this.localStorageService.getItem('hasjoblistingaccess')
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getTitles();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getTitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-current_tenure_median";
    aggReq.aggregatescount = this.jobTitleAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['current_jobtitle-current_tenure_median'];
      this.totalTitleResultCount = response.data.totalresultscount;
      tempData.map(res => {
        res.avg_tenure = res.current_tenure_median.value;
        return res;
      });
      this.titlesortdata = tempData;
      this.gettitlesdataai(this.titlesortdata, 'jobtitles')
      this.totalCountTitle = tempData.length;
      this.titles = tempData.slice(this.startTitle, this.endTitle);
      //  this.titlesdata =  new MatTableDataSource(this.titles);

      this.showTitleLoader = false;
      this.titleemptystate = true;
      this.manualjobtitleSort();
      this.getFunction();
      this.getJobsAggregates();

    });
  }

  getFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function-current_tenure_median";
    aggReq.aggregatescount = this.functionAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations['current_function-current_tenure_median'];
      tempData.map(res => {
        res.median_tenure = res.current_tenure_median.value;
        return res;
      });
      this.functionsortdata = tempData;
      this.gettitlesdataai(this.functionsortdata, 'functions')
      //     this.functions = tempData.slice(this.startFunction, this.endFunction);
      this.totalCountFunction = tempData.length;
      //   this.functionsdata = new MatTableDataSource(this.functions)
      this.functionemptystate = true;
      this.manualfunctionsort();
      this.getSeniority();
      this.getFunctionAggregate();
    });
  }

  /**
 * Function set the start and end of aggreggate data according to page number in title container
 * @param index page number in pagination
 */
  setPageTitles(index: number) {
    this.startTitle = (index - 1) * this.pageSizeTitle;
    this.endTitle = this.startTitle + this.pageSizeTitle;
    this.currentPageTitle = index;
      this.manualjobtitleSort();

  }

  /**
* Function set the start and end of aggreggate data according to page number in title container
* @param index page number in pagination
*/
  setPageFunction(index: number) {
    this.startFunction = (index - 1) * this.pageSizeFunction;
    this.endFunction = this.startFunction + this.pageSizeFunction;
    this.currentPageFunction = index;
      this.manualfunctionsort();

  }

  getTitlePercentage(value) {
    return ((value / this.totalTitleResultCount) * 100).toFixed(2);
  }

  getFunctionPercentage(value) {
    return ((value / this.totalFunctionResultCount) * 100).toFixed(2);
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  manualjobtitleSort() {
    this.reSortjobtitleArray(this.titlesort);
  }

  private reSortjobtitleArray(sort: MatSort) {
    const data = this.titlesortdata;
    if (!sort || !sort.active || sort.direction === '') {
      this.titles = data.slice(this.startTitle, this.endTitle);
      this.titlesdata = new MatTableDataSource(this.titles);
      return;
    }

    this.titlesortdata = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'avg_tenure': return this.compare(a.avg_tenure, b.avg_tenure, isAsc);

        default: return 0;
      }
    });
    this.titles = this.titlesortdata.slice(this.startTitle, this.endTitle);
    this.titlesdata = new MatTableDataSource(this.titles);
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  manualfunctionsort() {
    this.reSortfunctionArray(this.functionsort);
  }

  reSortfunctionArray(sort) {
    const data = this.functionsortdata;
    if (!sort || !sort.active || sort.direction === '') {
      this.functions = data.slice(this.startFunction, this.endFunction);
      this.functionsdata = new MatTableDataSource(this.functions)
      return;
    }

    this.functionsortdata = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'median_tenure': return this.compare(a.median_tenure, b.median_tenure, isAsc);
        default: return 0;
      }
    });
    this.functions = this.functionsortdata.slice(this.startFunction, this.endFunction);
    this.functionsdata = new MatTableDataSource(this.functions)
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
       const redirectFilters: Partial<FilterParams> = {
                    // Company context — always present
                    companyid: this.companyDetails?.id,
                    companyname: this.currentCompanyName,
                    alternativecompanynames: this.alternatecompanyNames,

                    // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
                    // sidebar). Nested so it can never collide with the listing page's normal filters.
                    insightsFilterData: this.filterData,
                  };
    switch (type) {
      case 'jobtitle': redirectFilters['mandatoryjobtitles'] = [key]; break;
      case 'functions': redirectFilters['mandatoryfunctions'] = [key]; break;
    }

       const uniqueKey = this.hashService.generateUniqueHash();
          localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

          const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
          window.open(url, '_blank');
  }

  getonedigitnumber(number) {
    return number.toFixed(1);
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  gettitlesdataai(data, type) {
    if (type == 'jobtitles') {
      this.jobtitlesdata = data.map(x => {
        let res: any = {};
        res['Job Titles'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['% of Total'] = this.getTitlePercentage(x.doc_count) + '%';
        res['Median Tenure'] = Math.round(x.avg_tenure * 100) / 100 + 'yrs';
        res['Job Posts'] = x.job_doc_count || 0;
        return res;
      })
    }
    if (type == 'functions') {
      this.functionsaidata = data.map(x => {
        let res: any = {};
        res['Role'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['% of Total'] = this.getFunctionPercentage(x.doc_count) + '%';
        res['Median Tenure'] = Math.round(x.median_tenure * 100) / 100 + 'yrs';
        res['Job Posts'] = x.job_doc_count || 0;
        return res;
      })
    }
    if(type == 'seniority') {
        this.seniorityAiData = data.map(x => {
          let res: any = {};
          res['role'] = x.key;
          res['Talent Count'] = x.doc_count;
          res['Job Posts'] = x.job_doc_count || 0;
          return res;
        });
    }

    this.titlesdataAI = {
      jobtitles: this.jobtitlesdata,
      functions: this.functionsaidata,
      seniority: this.seniorityAiData

    }
    if (this.jobtitlesdata.length == 0 && this.functionsaidata.length == 0 && this.seniorityAiData.length == 0) {
      this.titlesdataAI = null;
    }
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if (requestData?.data?.currentTab !== 'titles') return;

    this.tableHeaderName = [this.tableHeaderObj['jobTitles'], this.tableHeaderObj['TalentCount'], this.tableHeaderObj['%OfTotal'], this.tableHeaderObj['MedianTenure'], this.tableHeaderObj['JobDemand']];
    const senioritytableHeaderObj = [this.senioritytableHeaderObj["Title"], this.senioritytableHeaderObj["TalentCount"], this.senioritytableHeaderObj["JobDemand"]];
    const titlesDataForExport = this.titlesortdata.map(title => {
      return {
        ...title,
        job_doc_count: title.job_doc_count || '—',
      };
    });

    const functionDataForExport = this.functionsortdata.map(func => {
      return {
        ...func,
        job_doc_count: func.job_doc_count || '—',
      };
    });

    const seniorityDataForExport = this.senioritySortData.map(seniority => {
      return {
        ...seniority,
        job_doc_count: seniority.job_doc_count || '—',
      };
    });
    const payloadForInsightsExport: ExportPayload = {
      tab: 'titles',
      companydetails: this.companyDetails,
      totalresultcount: this.totalTitleResultCount,
      titles: titlesDataForExport,
      functions: functionDataForExport,
      tableHeader: this.tableHeaderName,
      seniority: {tableHeader: senioritytableHeaderObj, data: seniorityDataForExport}

    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getSeniority() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    aggReq.aggregatescount = this.jobTitleAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['seniority'];
      this.totalTitleResultCount = response.data.totalresultscount;
      // this.seniorityData = tempData;
      console.log("seniority data", tempData);
      // tempData.map(res=>{
      //   res.avg_tenure = res.current_tenure_median.value;
      //   return res;
      // });
      this.senioritySortData = tempData;
      this.seniorityEmptyState = true;
        this.gettitlesdataai(this.senioritySortData, 'seniority')

      this.manualSenioritySort();
      this.getSeniorityAggregates();
    });
  }

  manualSenioritySort() {
    this.reSortseniorityArray(this.senioritySort);
  }

  private reSortseniorityArray(sort: MatSort) {
    const data = this.senioritySortData;
    if (!sort || !sort.active || sort.direction === '') {
      this.seniority = data.slice(this.startTitle, this.endTitle);
      this.senioritydata = new MatTableDataSource(this.seniority);
      return;
    }

    this.senioritySortData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);

        default: return 0;
      }
    });
    this.seniority = this.senioritySortData.slice(this.startTitle, this.endTitle);
    this.senioritydata = new MatTableDataSource(this.seniority);
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    this.titlesortdata = this.titlesortdata.map(titles => {
      titles.job_doc_count = '';
      return titles;
    });

    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "jobs_base_aggregates";
    request.aggregatescount = 50;
    request.companyids = [this.companyDetails.id];
    this.personSearchService.getTotalAggs(request).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      this.getJobsAggregates();
      this.getSeniorityAggregates();
      this.getFunctionAggregate();
    });
  }

  getJobsAggregates() {
  this.hasJobDemand = true;
    this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'jobtitle-job_demand',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],

    }
    this.sliderPayload = payload

    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['jobtitle-job_demand'];
      this.hasJobDemand = false;
      this.titlesortdata.map(titles => {
        const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === titles.key.toLowerCase().trim());
        if (medianSalaryData) {
          titles.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
        } else {
          titles.job_doc_count = '';
        }
        return titles;
      });
      this.gettitlesdataai(this.titlesortdata, 'jobtitles')
    })
  }

  getSeniorityAggregates() {
 this.hasJobDemand = true;
    this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'seniority-job_demand',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
  excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
    this.sliderSeniorityPayload = payload

    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['seniority-job_demand'];
      this.hasJobDemand = false;
      this.hasMedianSalarySeniority = false;
      this.senioritySortData.map(title => {
        const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === title.key.toLowerCase().trim());
        if (medianSalaryData) {

          title.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
        } else {

          title.job_doc_count = '';
        }
        return title;
      });
      this.gettitlesdataai(this.senioritySortData, 'seniority')
    })
  }

    getFunctionAggregate() {
   this.hasJobDemand = true;
    this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'function-job_demand',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
  excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
    this.sliderFunctionsPayload = payload

    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['function-job_demand'];
      this.hasJobDemand = false;
      this.hasMedianSalarySeniority = false;
      this.functionsortdata.map(func => {
        const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === func.key.toLowerCase().trim());
        if (medianSalaryData) {

      func.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
        } else {

          func.job_doc_count = '';
        }
        return func;
      });
      this.gettitlesdataai(this.functionsortdata, 'functions')
    })
  }
  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus(){
    return this.hasJobDemand || this.hasMedianSalarySeniority;
  }

   openJoblistSlider(type:any, value:any){
    if(type == 'jobtitles'){
      Object.assign(this.sliderPayload, {mandatory_jobtitles:[value]})
      this.sendDataToSliderSubject.next(this.sliderPayload);

    }else if(type == 'functions'){
      Object.assign(this.sliderFunctionsPayload, {mandatory_functions:[value]})
      this.sendDataToSliderSubject.next(this.sliderFunctionsPayload);

    } else if(type == 'seniority'){
      Object.assign(this.sliderSeniorityPayload, {mandatory_seniority:[value]})
      this.sendDataToSliderSubject.next(this.sliderSeniorityPayload);

    }

      this.toOpenSliderFromTabSubject.next({isOpen:true})
    }
  getJobtitleSkillSuggestions() {
    const aggReq = this.aggService.getRequestWithFilters();
    if ((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0) {
      const payload = {
        skills: aggReq.preferredskills,
        jobtitles: aggReq?.jobtitles,
        boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
      }

      this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(async (res: any) => {
        const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
          jobtitles: titles,
          skills: skills
        }
        this.localStorageService.setItem('companyaiSuggestions', filterSuggestions);
        this.fetchPageData();


      })
    } else {
      this.localStorageService.setItem('companyaiSuggestions', null);
      this.fetchPageData();
    }
  }
}
